import React, { useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { getAlert } from "../Services/appAlerts";
import { useDispatch, useSelector } from "react-redux";
import {
  appDocumentUploaded,
  getAppDocUploadSasUrl,
  getAppDocUploadStatus,
  uploadAppDocuments,
} from "../app/store/documents";
import { getCurrentUser } from "../app/store/auth";
import { uploadFileToBlob } from "../Services/blobUploadService";

const UPLOAD_DOC_POPUP_STYLES = {
  modalContent: {
    borderRadius: "26px",
    overflow: "hidden",
    border: "1px solid rgba(226, 232, 240, 1)",
    boxShadow: "0 24px 60px rgba(15, 23, 42, 0.16)",
  },
  modalDialog: {
    maxWidth: "920px",
  },
  modalHeader: {
    padding: "18px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "linear-gradient(135deg, rgba(248, 250, 252, 0.98) 0%, rgba(239, 246, 255, 0.95) 100%)",
  },
  headerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "14px",
  },
  titleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
  },
  headerIcon: {
    width: "46px",
    height: "46px",
    borderRadius: "15px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(79, 70, 229, 0.16) 100%)",
    color: "#4338ca",
    fontSize: "21px",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.6)",
  },
  title: {
    fontSize: "22px",
    fontWeight: 800,
    color: "#0f172a",
    lineHeight: 1.1,
    margin: 0,
  },
  subtitle: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px",
  },
  closeButton: {
    width: "38px",
    height: "38px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 800,
    boxShadow: "0 8px 18px rgba(15, 23, 42, 0.06)",
    flexShrink: 0,
  },
  modalBody: {
    padding: "20px 22px 22px 22px",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
  },
  helperCard: {
    borderRadius: "16px",
    padding: "16px",
    background: "linear-gradient(135deg, rgba(248,250,252,0.98) 0%, rgba(239,246,255,0.9) 100%)",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    marginBottom: "16px",
  },
  helperTitle: {
    fontSize: "14px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "8px",
  },
  helperText: {
    fontSize: "12px",
    lineHeight: 1.7,
    color: "#64748b",
    margin: 0,
  },
  sectionCard: {
    borderRadius: "20px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "0 12px 26px rgba(15, 23, 42, 0.05)",
    padding: "18px",
    marginBottom: "16px",
  },
  sectionTitle: {
    fontSize: "15px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "6px",
  },
  sectionSubtitle: {
    fontSize: "12px",
    lineHeight: 1.6,
    color: "#64748b",
    marginBottom: "14px",
  },
  dropZone: {
    border: "2px dashed rgba(148, 163, 184, 0.45)",
    borderRadius: "20px",
    padding: "30px 22px",
    textAlign: "center",
    background: "linear-gradient(180deg, rgba(248,250,252,0.88) 0%, rgba(255,255,255,1) 100%)",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  dropZoneActive: {
    borderColor: "rgba(59, 130, 246, 0.7)",
    background: "linear-gradient(180deg, rgba(239,246,255,0.95) 0%, rgba(255,255,255,1) 100%)",
    boxShadow: "inset 0 0 0 1px rgba(147, 197, 253, 0.55)",
  },
  dropIcon: {
    width: "60px",
    height: "60px",
    margin: "0 auto 14px auto",
    borderRadius: "18px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, rgba(37,99,235,0.12) 0%, rgba(79,70,229,0.16) 100%)",
    color: "#4338ca",
    fontSize: "26px",
  },
  dropTitle: {
    fontSize: "16px",
    fontWeight: 800,
    color: "#0f172a",
    marginBottom: "6px",
  },
  dropText: {
    fontSize: "13px",
    lineHeight: 1.7,
    color: "#64748b",
    margin: 0,
  },
  fileList: {
    display: "grid",
    gap: "12px",
  },
  fileRow: {
    borderRadius: "16px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#f8fbff",
    padding: "12px 14px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
  },
  fileMeta: {
    minWidth: 0,
    flex: 1,
  },
  fileName: {
    fontSize: "13px",
    fontWeight: 700,
    color: "#0f172a",
    wordBreak: "break-word",
  },
  fileSubtext: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px",
  },
  removeButton: {
    width: "34px",
    height: "34px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  textArea: {
    minHeight: "110px",
    borderRadius: "16px",
    border: "1px solid rgba(203, 213, 225, 1)",
    padding: "12px 14px",
    fontSize: "13px",
    color: "#0f172a",
    resize: "vertical",
    width: "100%",
    outline: "none",
  },
  footerActions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    flexWrap: "wrap",
  },
  cancelButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#475569",
    padding: "10px 14px",
    fontSize: "12px",
    fontWeight: 800,
  },
  sendButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "none",
    background: "linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)",
    color: "#ffffff",
    padding: "10px 16px",
    fontSize: "12px",
    fontWeight: 800,
    boxShadow: "0 14px 28px rgba(79, 70, 229, 0.2)",
  },
  sendButtonDisabled: {
    opacity: 0.55,
    boxShadow: "none",
  },
};

const formatFileSize = (sizeInBytes) => {
  if (!sizeInBytes && sizeInBytes !== 0) return "";
  if (sizeInBytes < 1024) return `${sizeInBytes} B`;
  if (sizeInBytes < 1024 * 1024) return `${(sizeInBytes / 1024).toFixed(1)} KB`;
  return `${(sizeInBytes / (1024 * 1024)).toFixed(1)} MB`;
};

const UploadDocPopup = (props) => {
  const {
    uploadDocShowHide,
    handleUploadDocModalShowHide,
    selectedDocType,
    runningApplication,
    messageAlert,
    contactDoc = "",
  } = props;

  const [documents, setDocuments] = useState([]);
  const [notes, setNotes] = useState("");
  const [btnProcess, setBtnProcess] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  const appDocUploadStatusSelector = useSelector(getAppDocUploadStatus);
  const appDocUploadSasUrlSelector = useSelector(getAppDocUploadSasUrl);

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (!uploadDocShowHide) {
      setDocuments([]);
      setNotes("");
      setBtnProcess(false);
      setIsDragging(false);
    }
  }, [uploadDocShowHide]);

  const addFiles = (fileList) => {
    const incomingDocs = Array.from(fileList || []).map((file) => ({
      name: file.name,
      type: file.type,
      size: file.size,
      file,
    }));

    if (incomingDocs.length === 0) return;

    setDocuments((prev) => [...prev, ...incomingDocs]);
  };

  const doSubmit = () => {
    if (!documents.length) {
      getAlert("", "Document not found", "error");
      return;
    }

    if (!runningApplication || !runningApplication[0]) {
      getAlert("", "Workflow details not found", "error");
      return;
    }

    setBtnProcess(true);
    let usrId = currentUser.id;
    if (currentUser.linkUser) usrId = currentUser.linkUser;

    const frmData = new FormData();
    frmData.append("message", notes);
    frmData.append("workflowTask", JSON.stringify(runningApplication[0]));
    frmData.append("userId", usrId);
    frmData.append("docType", !selectedDocType ? "" : selectedDocType);
    frmData.append(
      "files",
      JSON.stringify(
        documents.map((file) => ({
          name: file.name,
          type: file.type,
          size: file.size,
        }))
      )
    );
    dispatch(uploadAppDocuments(frmData));
  };

  useEffect(() => {
    if (appDocUploadStatusSelector > 0) {
      setBtnProcess(false);
      if (messageAlert && messageAlert !== "") {
        getAlert("", messageAlert, "success");
      } else {
        getAlert("", `${contactDoc === "" ? "Sent Successfully" : contactDoc}`, "success");
      }
      dispatch(appDocumentUploaded(null));
      handleUploadDocModalShowHide("save", "");
    }
  }, [appDocUploadStatusSelector]);

  useEffect(() => {
    const uploadAllDocuments = async () => {
      if (appDocUploadSasUrlSelector && appDocUploadSasUrlSelector?.length > 0) {
        try {
          await Promise.all(
            documents.map((file, key) =>
              uploadFileToBlob(file.file, appDocUploadSasUrlSelector[key]?.uploadUrl, () => {})
            )
          );
          dispatch(appDocumentUploaded(null));
        } catch (error) {
          console.error("Upload failed:", error);
          setBtnProcess(false);
          getAlert("", "File upload failed", "error");
        }
      }
    };
    uploadAllDocuments();
  }, [appDocUploadSasUrlSelector]);

  const onFileChange = (event) => {
    addFiles(event.target.files);
    event.target.value = "";
  };

  const handleFileRemove = (item) => {
    const updatedDocuments = documents.filter((doc) => doc !== item);
    setDocuments(updatedDocuments);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    addFiles(e.dataTransfer.files);
  };

  const totalFiles = documents.length;
  const totalSize = documents.reduce((sum, item) => sum + (item.size || 0), 0);

  return (
    <Modal
      show={uploadDocShowHide}
      size="xl"
      centered
      onHide={() => handleUploadDocModalShowHide("", "")}
      dialogClassName="upload-doc-popup-modal-dialog"
      contentClassName="upload-doc-popup-modal-content"
    >
      <style>
        {`
          .upload-doc-popup-modal-dialog {
            max-width: ${UPLOAD_DOC_POPUP_STYLES.modalDialog.maxWidth};
          }
          .upload-doc-popup-modal-content {
            border-radius: ${UPLOAD_DOC_POPUP_STYLES.modalContent.borderRadius};
            overflow: ${UPLOAD_DOC_POPUP_STYLES.modalContent.overflow};
            border: ${UPLOAD_DOC_POPUP_STYLES.modalContent.border};
            box-shadow: ${UPLOAD_DOC_POPUP_STYLES.modalContent.boxShadow};
          }
        `}
      </style>

      <Modal.Header style={UPLOAD_DOC_POPUP_STYLES.modalHeader}>
        <div style={UPLOAD_DOC_POPUP_STYLES.headerContent}>
          <Modal.Title as="div" style={UPLOAD_DOC_POPUP_STYLES.titleWrap}>
            <div style={UPLOAD_DOC_POPUP_STYLES.headerIcon}>
              <i className="fa fa-cloud-upload" aria-hidden="true"></i>
            </div>
            <div>
              <div style={UPLOAD_DOC_POPUP_STYLES.title}>Upload Documents</div>
              <div style={UPLOAD_DOC_POPUP_STYLES.subtitle}>
                Add one or more files, include an optional message, and send everything in a single upload.
              </div>
            </div>
          </Modal.Title>
          <button
            type="button"
            style={UPLOAD_DOC_POPUP_STYLES.closeButton}
            onClick={() => handleUploadDocModalShowHide("", "")}
            aria-label="Close upload document popup"
          >
            <i className="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
      </Modal.Header>

      <Modal.Body style={UPLOAD_DOC_POPUP_STYLES.modalBody}>
        <div style={UPLOAD_DOC_POPUP_STYLES.helperCard}>
          <div style={UPLOAD_DOC_POPUP_STYLES.helperTitle}>Upload guidance</div>
          <p style={UPLOAD_DOC_POPUP_STYLES.helperText}>
            Drag files into the drop area or browse from your device. You can upload multiple documents
            at once and include a note to help reviewers understand what was sent.
          </p>
        </div>

        <div style={UPLOAD_DOC_POPUP_STYLES.sectionCard}>
          <div style={UPLOAD_DOC_POPUP_STYLES.sectionTitle}>Files</div>
          <div style={UPLOAD_DOC_POPUP_STYLES.sectionSubtitle}>
            {totalFiles > 0
              ? `${totalFiles} file${totalFiles > 1 ? "s" : ""} selected, ${formatFileSize(totalSize)} total`
              : "No files selected yet."}
          </div>

          <div
            style={{
              ...UPLOAD_DOC_POPUP_STYLES.dropZone,
              ...(isDragging ? UPLOAD_DOC_POPUP_STYLES.dropZoneActive : {}),
            }}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
            onClick={() => fileInputRef.current?.click()}
          >
            <div style={UPLOAD_DOC_POPUP_STYLES.dropIcon}>
              <i className="fa fa-paperclip" aria-hidden="true"></i>
            </div>
            <div style={UPLOAD_DOC_POPUP_STYLES.dropTitle}>
              {isDragging ? "Drop files here" : "Drag and drop files here"}
            </div>
            <p style={UPLOAD_DOC_POPUP_STYLES.dropText}>
              {isDragging
                ? "Release to add the selected files."
                : "Or click anywhere in this area to browse and select documents."}
            </p>
          </div>
        </div>

        {documents.length > 0 && (
          <div style={UPLOAD_DOC_POPUP_STYLES.sectionCard}>
            <div style={UPLOAD_DOC_POPUP_STYLES.sectionTitle}>Selected documents</div>
            <div style={UPLOAD_DOC_POPUP_STYLES.sectionSubtitle}>
              Review the files below before sending them.
            </div>

            <div style={UPLOAD_DOC_POPUP_STYLES.fileList}>
              {documents.map((file, index) => (
                <div key={`${file.name}-${index}`} style={UPLOAD_DOC_POPUP_STYLES.fileRow}>
                  <div style={UPLOAD_DOC_POPUP_STYLES.fileMeta}>
                    <div style={UPLOAD_DOC_POPUP_STYLES.fileName}>{file.name}</div>
                    <div style={UPLOAD_DOC_POPUP_STYLES.fileSubtext}>
                      {formatFileSize(file.size)}
                      {file.type ? ` | ${file.type}` : ""}
                    </div>
                  </div>
                  <button
                    type="button"
                    style={UPLOAD_DOC_POPUP_STYLES.removeButton}
                    onClick={() => handleFileRemove(file)}
                    aria-label={`Remove ${file.name}`}
                  >
                    <i className="fa fa-times" aria-hidden="true"></i>
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}

        <div style={UPLOAD_DOC_POPUP_STYLES.sectionCard}>
          <div style={UPLOAD_DOC_POPUP_STYLES.sectionTitle}>Message</div>
          <div style={UPLOAD_DOC_POPUP_STYLES.sectionSubtitle}>
            Add any context or notes for the uploaded documents.
          </div>
          <textarea
            name="message"
            id="message"
            className="form-control"
            value={notes}
            onChange={({ currentTarget }) => setNotes(currentTarget.value)}
            style={UPLOAD_DOC_POPUP_STYLES.textArea}
            placeholder="Add a short note for the reviewer or support team."
          ></textarea>
        </div>

        <div style={UPLOAD_DOC_POPUP_STYLES.footerActions}>
          <button
            type="button"
            style={UPLOAD_DOC_POPUP_STYLES.cancelButton}
            onClick={() => handleUploadDocModalShowHide("", "")}
          >
            <i className="fa fa-times" aria-hidden="true"></i>
            Cancel
          </button>
          <Button
            type="button"
            style={{
              ...UPLOAD_DOC_POPUP_STYLES.sendButton,
              ...(btnProcess || documents.length === 0
                ? UPLOAD_DOC_POPUP_STYLES.sendButtonDisabled
                : {}),
            }}
            onClick={doSubmit}
            disabled={btnProcess || documents.length === 0}
          >
            <i
              className={`fa ${btnProcess ? "fa-circle-o-notch fa-spin" : "fa-paper-plane-o"}`}
              aria-hidden="true"
            ></i>
            {btnProcess ? "Sending..." : "Send"}
          </Button>
        </div>

        <input
          type="file"
          ref={fileInputRef}
          onChange={onFileChange}
          aria-label="Upload files"
          multiple
          style={{ display: "none" }}
        />
      </Modal.Body>
    </Modal>
  );
};

export default UploadDocPopup;
